<sn-slide-toggle
  ngDefaultControl
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [tabindex]="templateOptions.tabindex || 0"
  (toggleChange)="onToggleChange($event)"
>
  {{ templateOptions.toggleLabel }}
</sn-slide-toggle>
